import { Skeleton, Stack, Typography, styled } from "@mui/material";
import { useEffect, useState } from "react";
import { RedFlagQuestion } from "../types";
import * as apiClient from "../api";
import { RedFlagCard } from "../components";

const LoadingCard = styled(Skeleton)({
  height: "6rem",
});

const RedFlagsChecklist = () => {
  const [loaded, setLoaded] = useState(false);
  const [redFlags, setRedFlags] = useState<RedFlagQuestion[]>([]);

  useEffect(() => {
    const loadRedFlags = async () => {
      const res = await apiClient.getRedFlags();
      setRedFlags(res.data.questions);
      setLoaded(true);
    };

    loadRedFlags();
  }, []);

  return (
    <Stack spacing={2}>
      <Typography variant="h4">Red Flags Checklist</Typography>
      <Stack spacing={2}>
        {!loaded ? (
          <>
            <LoadingCard variant="rounded" />
            <LoadingCard variant="rounded" />
            <LoadingCard variant="rounded" />
          </>
        ) : (
          redFlags.map((redFlag, idx) => (
            <RedFlagCard
              key={redFlag.question}
              index={idx + 1}
              redFlag={redFlag}
            />
          ))
        )}
      </Stack>
    </Stack>
  );
};

export default RedFlagsChecklist;
